import allSalesStats from '@/routes/reportMng/allSalesStats'
import instSalesStats from '@/routes/reportMng/instSalesStats'
import spfc from '@/routes/reportMng/spfc'
import camp from '@/routes/reportMng/camp'
import lect from '@/routes/reportMng/lect'
import common from '@/routes/reportMng/common'

const routes = [
    ...allSalesStats,    // 전체 매출현황
    ...instSalesStats,   // 기관별 매출현황
    ...spfc,             // 체육시설
    ...camp,             // 캠핑장
    ...lect,             // 교육/강좌
    ...common,           // 공통 팝업
]

export default routes